import { render, staticRenderFns } from "./UsersEditPopup.vue?vue&type=template&id=4735ba63&"
import script from "./UsersEditPopup.vue?vue&type=script&lang=js&"
export * from "./UsersEditPopup.vue?vue&type=script&lang=js&"
import style0 from "./UsersEditPopup.vue?vue&type=style&index=0&id=4735ba63&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports